import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PLANNED_MAINTENANCE_TEMPLATES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'PLANNED_MAINTENANCE_TEMPLATES'
);
export const PLANNED_MAINTENANCE_TEMPLATES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PLANNED_MAINTENANCE_TEMPLATES_CRUD_ACTION_CONSTANTS
);
